export enum ViewPinnedDefinition {
  None = 0,
  Left = 10,
}
